import React from 'react'
import { NavLink } from 'react-router-dom'

export interface SubTab {
  to: string
  label: string
  // Only active on an exact match (for an "Overview" tab whose path prefixes the others)
  end?: boolean
}

// Smaller sibling of the header nav, for pages with their own sections
const SubTabs: React.FC<{ tabs: SubTab[]; ariaLabel: string }> = ({ tabs, ariaLabel }) => (
  <nav className="sub-tabs" aria-label={ariaLabel}>
    {tabs.map(tab => (
      <NavLink
        key={tab.to}
        to={tab.to}
        end={tab.end}
        className={({ isActive }) => `sub-tab${isActive ? ' active' : ''}`}
      >
        {tab.label}
      </NavLink>
    ))}
  </nav>
)

export default SubTabs
